import { Apollo } from 'apollo-angular';
import { ApolloQueryResult } from '@apollo/client/core';
import { DocumentNode } from 'graphql';
import { Observable } from 'rxjs';

class Resolver {
  private subscriptionForQuery: any;
  private subscriptionForModified: any;
  private subscriber: any;

  constructor(
    private apollo: Apollo,
    private variables: any,
    private listQuery: any,
    private subscriptionQuery: any,
    private applyCallback: any
  ) {}

  getResult() {
    return new Observable<any>((subscriber) => {
      const options: any = {
        query: this.listQuery,
        fetchPolicy: 'network-only',
      };
      if (this.variables) options.variables = this.variables;

      this.apollo.query(options).subscribe({
        next: (res: any) => {
          const list = res?.data?.task?.list;
          const gqlErr = list?.errors;
          if (gqlErr && (gqlErr.status && gqlErr.status !== 200)) {
            subscriber.error({
              status: gqlErr.status,
              message: gqlErr.message,
              errorData: gqlErr.errorData,
            });
            return;
          }
          subscriber.next(res);
        },
        error: (err) => {
          subscriber.error(err);
        },
        complete: () => subscriber.complete(),
      });
    });
  }
}

export abstract class FilteredListServiceBase<T> {
  constructor(public apollo: Apollo) {}

  getList(
    variables,
    querySource?: DocumentNode
  ): Observable<ApolloQueryResult<T>> {
    const resolver = new Resolver(
      this.apollo,
      variables,
      this.getListQuery(querySource),
      this.getMutationQuery(),
      this.applyNewData
    );
    return resolver.getResult() as Observable<ApolloQueryResult<T>>;
  }

  abstract getListQuery(querySource?: DocumentNode);

  abstract getMutationQuery();

  abstract applyNewData(newResult);
}
